<template>
  <div ref="recipients" class="recipients-graph-section">
    <h5 class="data-title text-center">recipients vs non recipients</h5>

    <select-by-type @setDataType="setReportDataType"></select-by-type>

    <div v-if="error" class="error-label text-center">{{error}}</div>

    <div v-if="graphData && graphData.length && !error"
         class="report-legend recipients">
      <span class="recipients-legend">recipients</span>
      <span class="non-recipients-legend">non-recipients</span>
    </div>

    <bar-graph v-if="graphData && wrapperWidth && !error"
               :barSelectorData="['recipient', 'nonrecipient']"
               :graphData="graphData"
               :toolTipContent="toolTipContent"
               :useCurrency="useCurrency"
               :wrapperWidth="wrapperWidth"
               xSelector="date_time"
               :yTickFormat="yTickFormat"
               @setToolTipContent="setToolTipContent"></bar-graph>

  </div>
</template>

<script>
  import BarGraph from '../Graphs/BarGraph'
  import Reports from '../mixins/Reports'
  import SelectByType from './SelectByType'
  import ToolTip from '../mixins/ToolTipContent'

  export default {
    props: {
      apiParams: Object,
      error: String,
      graphData: Array,
      isTracked: Boolean,
      wrapperWidth: [Number, String],
    },

    name: 'RecipientsReport',

    components: {
      BarGraph,
      SelectByType,
    },

    mixins: [Reports, ToolTip],

    data() {
      return {
        errorMessage: null,
        showDataTypeList: false,
      }
    },

    methods: {
      loadGraphData() {
        this.$emit('loadGraphData', '/performance/conversion_rate', 'recipients', this.metric)
      },

      setReportDataType(dataType) {
        if (this.reportDataType !== dataType) {
          this.reportDataType = dataType
          this.loadGraphData()
        }
      },

      setToolTipContent(item) {
        this.toolTipContent = this.getToolTipContent(item, 'recipients')
      },

    },

    created() {
      this.loadGraphData()
    },

    watch: {
      apiParams: function() {
        this.loadGraphData()
      },
    },
  }
</script>

<style lang="sass">
  //
  //  recipients report
  //
  .report-graphs-section .recipients-graph-section
    .data-title
      margin-bottom: 0

  .recipients-graph-section
    .report-legend
      margin: 10px 0 0 20px

      span
        font-weight: bold
        margin: 0 1rem

    .recipients-legend
      color: #128ff9

    .non-recipients-legend
      color: #44e5e7

    @media only screen and (max-width: 40em)
      width: 100%
</style>